
import React from "react";
import LoadingPage from "./loading";

class SystemHealthPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      report: null,
      loading: true,
      showReport: false,   // gate the report for 20 seconds
      showErrors: false  // error messages hidden until timer expires
    };

    this.POLL_INTERVAL = 3000;
    this.DOWN_ERROR_DELAY = 120000; // 2 minute
    this.intervalId = null;
    this.showTimer = null;

  }

  componentDidMount() {
    // initial fetch
    this.fetchHealth();

    // start polling
    this.intervalId = setInterval(() => this.fetchHealth(), this.POLL_INTERVAL);

     // wait 10 seconds before showing report
    this.showTimer = setTimeout(() => {
      this.setState({ showReport: true });
    }, 10000);

    // After 2 minutes, allow error messages to be shown
    this.errorTimer = setTimeout(() => {
      this.setState({ showErrors: true });
    }, this.DOWN_ERROR_DELAY);
  }

  componentWillUnmount() {
    // cleanup
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.showTimer) clearTimeout(this.showTimer);
    if (this.errorTimer) clearTimeout(this.errorTimer);
  }

  async fetchHealth() {
    try {
      const res = await fetch("/health/service-status");
      const data = await res.json();

      this.setState({ report: data, loading: false });

      // Stop polling if all services are up
      if (data.overallStatus === "ALL_SERVICES_UP") {
        clearInterval(this.intervalId);

        if (this.props.onAllUp) {
          this.props.onAllUp();   // ← notify parent
        }

      }
    } catch (err) {
      this.setState({
        report: { error: "Failed to fetch system health" },
        loading: false
      });
    }
  }

  render() {
    const { report, showReport } = this.state;

    // Still loading → show full screen loader
    if (!showReport || report === null) {
      return <LoadingPage />;
    }

    // If request failed
    if (report.error) {
      return (
        <div style={{ padding: 20 }}>
          <h2>⚠️ Could not load system health</h2>
          <p>{report ? report.error : "Unknown error"}</p>
        </div>
      );
    }

    // All services are UP
    if (report.overallStatus === "ALL_SERVICES_UP") {
      return (
        <div style={{ padding: 20 }}>
          <h1>🚀 All Systems Operational!</h1>
          <p>Last checked: {report.timestamp}</p>
        </div>
      );
    }

    // Otherwise show the intermediate health state
    return (
      <div className="login-overlay">
        <h1>UrbanAware Services</h1>
        <p><strong>Checked:</strong> {report.timestamp}</p>
        <ul>
          
          {report.services.map((s, i) => {
            const isUp = s.status === "UP";

            return (
              <li key={i} style={{ marginBottom: "8px", textAlign:"left"}}>
                <div style={{ display: "flex", gap: "8px" }}>
                <strong>{s.name}</strong> —{" "}

                {isUp ? (
                  <span style={{ color: "green", fontWeight: "bold", fontSize:14}}>✔ UP</span>
                ) : (
                  // Only show error message *after* 2 minutes:
                  this.state.showErrors ? (
                    <span style={{ color: "red", fontWeight: "bold", fontSize:14}}>✖  Error: {s.error}</span>
                  ) : (
                   <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>
                      <div className="service-spinner"></div><span style={{ color: "orange", fontWeight: "bold", fontSize:14}}>  Loading...</span>
                   </div>
                  )
                )}
                </div>
              </li>
            );
          })}

        </ul>
      </div>
    );
  }
}

export default SystemHealthPage;
